export var localHost = document.location.hostname == 'localhost' || document.location.hostname.startsWith('192');
export var baseUrl = localHost ? "http://" + document.location.hostname + ":3001" : document.location.origin;
export var _VERSION = "2.24.9.18.1.alpha";
